import AddressFieldWithLabel from "../../../Common/AddressField/AddressFieldWithLabel";
import usePaymentMethodOptions from "../../hooks/usePaymentMethodOptions";
import { isValidSplitInput, REVIEW_CONTRACT_OPTIONS } from "../../utils/paymentFormUtils";

import PaymentsCheckboxField from "./PaymentsCheckboxField";
import PaymentsDateField from "./PaymentsDateField";
import PaymentsModalField from "./PaymentsModalField";
import PaymentsSingleSelectDropdown from "./PaymentsSingleSelectDropdown";
import PaymentsTextField from "./PaymentsTextField";

const DIGITS_ONLY = /^\d*$/;
const DECIMAL_ONLY = /^\d*\.?\d*$/;

export default function PaymentsEditForm({ formValues, mode, onChange, openModal }) {
  const paymentMethodOptions = usePaymentMethodOptions(openModal);

  return (
    <div className="flex flex-col gap-4 p-6">
      <div className="flex w-full gap-4">
        <PaymentsModalField
          className="w-1/3"
          label="Payment Method"
          renderValue={
            <PaymentsSingleSelectDropdown
              fieldName="paymentMethod"
              fieldValue={formValues.paymentMethod}
              onChange={onChange}
              data={paymentMethodOptions}
            />
          }
        />
        <PaymentsModalField
          className="w-2/3"
          label="Bank Name"
          renderValue={
            <PaymentsTextField
              fieldName="bankName"
              fieldValue={formValues.bankName}
              onChange={onChange}
            />
          }
        />
      </div>
      <div className="flex w-full gap-4">
        <PaymentsModalField
          label="Routing Number"
          renderValue={
            <PaymentsTextField
              fieldName="routingNumber"
              fieldValue={formValues.routingNumber}
              onChange={onChange}
              inputMode="numeric"
              pattern={DIGITS_ONLY}
            />
          }
        />
        <PaymentsModalField
          label="Account Number"
          renderValue={
            <PaymentsTextField
              fieldName="accountNumber"
              fieldValue={formValues.accountNumber}
              onChange={onChange}
              inputMode="numeric"
              pattern={DIGITS_ONLY}
            />
          }
        />
      </div>
      <div className="flex w-full gap-4">
        <PaymentsModalField
          label="Valid From"
          renderValue={
            <PaymentsDateField
              fieldName="validFrom"
              fieldValue={formValues.validFrom}
              onChange={onChange}
            />
          }
        />
        <PaymentsModalField
          label="Valid To"
          renderValue={
            <PaymentsDateField
              fieldName="validTo"
              fieldValue={formValues.validTo}
              onChange={onChange}
            />
          }
        />
        <PaymentsModalField
          label="Review Contract"
          renderValue={
            <PaymentsSingleSelectDropdown
              fieldName="reviewContract"
              fieldValue={formValues.reviewContract}
              onChange={onChange}
              data={REVIEW_CONTRACT_OPTIONS}
            />
          }
        />
      </div>
      <div className="flex w-full gap-4">
        <PaymentsModalField
          label="Client Management Split"
          renderValue={
            <PaymentsTextField
              fieldName="clientManagementSplit"
              fieldValue={formValues.clientManagementSplit}
              onChange={onChange}
              inputMode="decimal"
              pattern={DECIMAL_ONLY}
              validator={(value) => isValidSplitInput(value, 3)}
            />
          }
        />
        <PaymentsModalField
          label="Provider Split"
          renderValue={
            <PaymentsTextField
              fieldName="providerSplit"
              fieldValue={formValues.providerSplit}
              onChange={onChange}
              inputMode="decimal"
              pattern={DECIMAL_ONLY}
              validator={(value) => isValidSplitInput(value, 3)}
            />
          }
        />
        <PaymentsModalField
          label="Marketing Split"
          renderValue={
            <PaymentsTextField
              fieldName="marketingSplit"
              fieldValue={formValues.marketingSplit}
              onChange={onChange}
              inputMode="decimal"
              pattern={DECIMAL_ONLY}
              validator={(value) => isValidSplitInput(value, 3)}
            />
          }
        />
      </div>
      <AddressFieldWithLabel
        label="Billing Address"
        initialAddress={formValues.billingAddress}
        fieldName="billingAddress"
        fieldValue={formValues.billingAddress}
        customOnChange={onChange}
        defaultEditingMode={false}
      />
      <PaymentsCheckboxField
        checked={Boolean(formValues.sameAsBillingAddress)}
        label="Same as billing address"
        onChange={(value) => onChange("sameAsBillingAddress", value)}
      />
      <AddressFieldWithLabel
        label="Mailing Address"
        initialAddress={formValues.mailingAddress}
        fieldName="mailingAddress"
        fieldValue={formValues.mailingAddress}
        customOnChange={onChange}
        defaultEditingMode={false}
      />
    </div>
  );
}
